import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface CancelTrialBookingParams {
  trialId: string;
}

export const cancelTrialBooking = async ({ trialId }: CancelTrialBookingParams) => {
  const response = await baseAPI.post<unknown>(`trialstudents/${trialId}/cancel`);
  return response.data;
};

export const useCancelTrialBooking = () => {
  return useMutation({
    mutationFn: (params: CancelTrialBookingParams) => cancelTrialBooking(params),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.TRIAL_STUDENTS],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.TRIAL_LIFECYCLE_CONFLICTS],
      });
    },
  });
};
